import PropTypes from 'prop-types';
import React from 'react';
import PhaseType from 'types/phase';

export const communication_error = ({ event: { kind, data: { phone_number, message } } }) =>
  <div className={kind}>
    { phone_number && `Error sending text to number: ${phone_number}.` }
    { phone_number && <br />}
    { message && `Error Message: ${message}` }
  </div>;


communication_error.propTypes = {
  event: PropTypes.shape({
    kind: PropTypes.string.isRequired,
    data: PropTypes.shape({
      phone_number: PropTypes.string.isRequired,
      message: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  phase: PhaseType,
};



// WEBPACK FOOTER //
// ./client/app/shared/components/PhaseHistoryCard/phaseEvents/communication_error.jsx